import * as config from './config.json';
import { buildGet } from './genericMethods';

const projectIdVariable = '{projectId}';

export const getEvolutionById = (projectId: number) => {
  const url = config.PROJECT_EVOLUTION.replace(projectIdVariable, projectId.toString());
  return buildGet(url);
};
